import { NavLink } from "react-router-dom"
import SideNav from "../SideNav"
import { RxDashboard } from "react-icons/rx";
import { IoSettingsOutline } from "react-icons/io5";

const UserNav = ({ expandedNav, setExpandedNav }) => {

    return (
        <SideNav expandedNav={expandedNav} setExpandedNav={setExpandedNav}>
            <div className=" text-gray-500 font-semibold mb-3 mt-6 uppercase text-lg">MENU</div>
            <NavLink className={({ isActive }) => (isActive ? ' text-tripstore-gold' : '')} to={'/user/dashboard'}>
                <div className=" flex items-center gap-4 cursor-pointer hover:text-tripstore-gold my-4">
                    <RxDashboard />
                    <span>Dashboard</span>
                </div>
            </NavLink>

            <div className=" text-gray-500 font-semibold mb-3 mt-6 uppercase text-lg">Others</div>
            <NavLink className={({ isActive }) => (isActive ? ' text-tripstore-gold' : '')} to={'/user/settings'}>
                <div className=" flex items-center gap-4 cursor-pointer hover:text-tripstore-gold my-4">
                    <IoSettingsOutline />
                    <span>Settings</span>
                </div>
            </NavLink>
        </SideNav>
    )
}

export default UserNav